import React, { useEffect, useReducer, createContext, Dispatch } from 'react';
import { KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN, KEY_USER_DETAILS } from '../constant';
import { AuthAction, AuthState } from '../../interfaces/Contexts';
import { ReactChildren } from '../../interfaces/Common';
import { Key } from '@mui/icons-material';

export interface AuthUser {
    ContactId: string;
    Name: string;
    Type: string;
    mail: string;
    // Add other relevant fields as needed
}

export const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  search: null,
};

const reducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'LOGIN':
      const userPayload = action.payload || { user: null };
      localStorage.setItem(KEY_REFRESH_TOKEN, userPayload.user?.refreshToken?.token ?? "");
      localStorage.setItem(KEY_ACCESS_TOKEN, userPayload.user?.accessToken?.token ?? "");
      localStorage.setItem(KEY_USER_DETAILS, JSON.stringify(userPayload.user));
      return {
        ...state,
        isAuthenticated: userPayload.user && userPayload.user === null ? false : true,
        user: userPayload.user || null,
      };
    case 'LOGOUT':
      localStorage.clear()
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        search: null,
      };
    default:
      return state;
  }
};

export const AuthContext = createContext<{
  state: AuthState;
  dispatch: Dispatch<AuthAction>;
}>({ state: initialState, dispatch: () => { } });

export const AuthContextProvider: React.FunctionComponent<ReactChildren> = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user =  localStorage.getItem(KEY_USER_DETAILS);
        if (user) {
          const parsedUser: AuthUser = JSON.parse(user);
          console.log('json', parsedUser);
          dispatch({
            type: 'LOGIN',
            payload: {
              user: parsedUser,
            },
          });
        }
      } catch (error) {
        console.error('Failed to fetch user data', error);
      }
    };

    fetchUserData();
  }, [dispatch]);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
